import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthDevelopersFormModel } from './auth-developers-form.model';

export class AuthDevelopersFormBuilder {
  public static createFormGroup(): FormGroup<AuthDevelopersFormModel> {
    return new FormGroup<AuthDevelopersFormModel>({
      username: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
    });
  }
}
